/**
 * DebugAxiosInterceptor
 * Componente que integra el interceptor de axios para capturar llamadas API
 * cuando el modo debug está activo.
 */
import { useEffect, useRef } from "react";
import { useDebug } from "../../../context/DebugContext";
import debugLogger from "../../../utils/debug/debugLogger";
import axios from "axios";
// También importamos la instancia personalizada si existe
import axiosMCM from "../../../utils/Apis/MCMCore/axios";

const DebugAxiosInterceptor = ({ children }) => {
  const { debugEnabled, isSupportUser } = useDebug();
  const cleanupFunctionsRef = useRef([]);

  useEffect(() => {
    // Solo activar si es usuario de soporte y debug está habilitado
    if (debugEnabled && isSupportUser) {
      // Interceptar instancia global de axios
      const cleanupGlobal = debugLogger.interceptAxios(axios);
      cleanupFunctionsRef.current.push(cleanupGlobal);

      // Interceptar instancia personalizada de MCM
      const cleanupMCM = debugLogger.interceptAxios(axiosMCM);
      cleanupFunctionsRef.current.push(cleanupMCM);

      console.info("[DebugAxiosInterceptor] Interceptors activados");
    }

    // Cleanup al desactivar o desmontar
    return () => {
      cleanupFunctionsRef.current.forEach((cleanup) => {
        try {
          cleanup();
        } catch (e) {
          // Ignorar errores de cleanup
        }
      });
      cleanupFunctionsRef.current = [];
    };
  }, [debugEnabled, isSupportUser]);

  return children;
};

export default DebugAxiosInterceptor;
